
import {throwError as observableThrowError, Observable} from 'rxjs';

import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Router} from '@angular/router';

import {UserInfoService} from '../user-info.service';
import {AppConfig} from '../../app-config';

@Injectable()
export class ApiRequestService {

    constructor(
        private appConfig: AppConfig,
        private http: HttpClient,
        private router: Router,
        private userInfoService: UserInfoService
    ) {
    }

    /**
     * This is a Global place to add all the request headers for every REST calls
     */
    getHeaders(): HttpHeaders {
        let headers = new HttpHeaders();
        const token = this.userInfoService.getStoredToken();
        headers = headers.append('Content-Type', 'application/json');
        if (token !== null) {
            headers = headers.append('Authorization', 'Bearer ' + token);
        }
        return headers;
    }

    getUploadHeaders(): HttpHeaders {
        let headers = new HttpHeaders();
        const token = this.userInfoService.getStoredToken();
        headers.set('Content-Type', null);
        headers.set('Accept', 'multipart/form-data');
        if (token !== null) {
            headers = headers.append('Authorization', 'Bearer ' + token);
        }
        return headers;
    }

    get(url: string, urlParams?: HttpParams): Observable<any> {
        const me = this;
        return this.http.get(url, {headers: this.getHeaders(), params: urlParams}).pipe(
            catchError(function (error: any) {
                console.log('Some error in catch');
                if (error.status === 401 || error.status === 403) {
                    me.router.navigate(['/auth/login']);
                }
                return observableThrowError(error || 'Server error');
            }));
    }

    post(url: string, body: Object): Observable<any> {
       // console.log('posttest', url, body)
        const me = this;
        return this.http.post(url, JSON.stringify(body), {headers: this.getHeaders()}).pipe(
            catchError(function (error: any) {
                if (error.status === 401) {
                    me.router.navigate(['/auth/login']);
                }
                return observableThrowError(error || 'Server error');
            }));
    }

    upload(url: string, body: Object): Observable<any> {
        const me = this;
        return this.http.post(url, body, {headers: this.getUploadHeaders()}).pipe(
            catchError(function (error: any) {
                if (error.status === 401) {
                    me.router.navigate(['/auth/login']);
                }
                return observableThrowError(error || 'Server error');
            }));
    }

    put(url: string, body: Object): Observable<any> {
        const me = this;
        return this.http.put(url, JSON.stringify(body), {headers: this.getHeaders()}).pipe(
            catchError(function (error: any) {
                if (error.status === 401) {
                    me.router.navigate(['/auth/login']);
                }
                return observableThrowError(error || 'Server error');
            }));
    }

    delete(url: string): Observable<any> {
        const me = this;
        return this.http.delete(url, {headers: this.getHeaders()}).pipe(
            catchError(function (error: any) {
                console.log('error: ' + error);
                if (error.status === 401) {
                    me.router.navigate(['/auth/login']);
                }
                return observableThrowError(error || 'Server error');
            }));
    }

}
